import {resetPassword} from '../.././../libs/api/api'
import constants from '../../../libs/constant/constants'
import {message, loader} from '../../../libs/helper'
import pageRoutes from '../../../libs/constant/pageRoutes'

export default {
    name:'ResetPasswordForm',
    data () {
        return {
            passwordType: 'password',
            confirmPasswordType: 'password',
            dynamicValidateForm: {
                password: '',
                confirmPassword: ''
            }
        }
    },
    methods: {
        hideShowPassword(type, key){
            this[key] = type;
        },
        submitForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if(this.dynamicValidateForm.confirmPassword === this.dynamicValidateForm.password){
                        loader(this, true);
                        let body={
                            newPassword: this.dynamicValidateForm.confirmPassword,
                            key: this.$route.params.verificationKey
                        }
                        resetPassword(body)
                            .then((response) => {
                                if(response.success){
                                    loader(this, false);
                                    message(this, constants.messageType.SUCCESS, (response.message))
                                    this.$router.push(pageRoutes.signIn)
                                }
                            })
                            .catch((error) => {
                                loader(this, false);
                                message(this, constants.messageType.ERROR, (error.message))
                            })
                    }else{
                        message(this, constants.messageType.ERROR, ('Password and Confirm password not matched'))
                    }

                }
            })
        }
    }
}